export const boatTo = {
  keyTable: "boatTo",
  caption: "Информация о прохождении технического освидетельствования",
  nameColumn: [
    {
      value: "Дата ТО",
      key: "toDate",
      type: "date",
      neededInModal: true,
    },
    {
      value: "Должностное лицо, проводившее ТО (ФИО)",
      key: "toUserid",
      type: "customSelect",
      placeholder: "Выберите",
      selectOptions: [],
      neededInModal: true,
      fieldModeView: true,
    },
    {
      value: "Годное/негодное",
      key: "result",
      type: "customSelect",
      placeholder: "Выберите",
      selectOptions: [
        { value: true, label: "Годное", key: "result" },
        { value: false, label: "Негодное", key: "result" },
      ],
      neededInModal: true,
    },
    {
      value: "Срок действия",
      key: "validityMonths",
      type: "customSelect",
      placeholder: "Выберите",
      disabled: false,
      selectOptions: [],
      neededInModal: true,
    },
    {
      value: "Дата акта ТО маломерного судна при признании его негодным (запрещенным к эксплуатации)",
      key: "actDate",
      type: "date",
      neededInModal: false,
      fieldModeView: true,
    },
    {
      value: "ФИО составителя",
      key: "recuser",
      type: "customSelect",
      placeholder: "Выберите",
      selectOptions: [],
      neededInModal: false,
      fieldModeView: true,
    },
  ],
};

export const optionsValidityMonths = [
  { value: 0, label: "—", key: "validityMonths" },
  { value: 12, label: "1 год", key: "validityMonths" },
  { value: 24, label: "2 года", key: "validityMonths" },
  { value: 36, label: "3 года", key: "validityMonths" },
  { value: 60, label: "5 лет", key: "validityMonths" },
];

export const setOptionsForInputsUsers = (users) => {
  const usersLibValid = users.map((item) => {
    return {
      ...item,
      value: item.userid,
      label: item.name,
    };
  });
  boatTo.nameColumn.forEach((item) => {
    if (item.key === "toUserid" || item.key === "recuser") {
      if (item.selectOptions.length === 0) {
        usersLibValid.forEach((elem) => {
          const newElem = { ...elem, key: item.key };
          item.selectOptions.push(newElem);
        });
      }
    }
  });
};

export const handleValidityMonthsDisabled = (value) => {
  boatTo.nameColumn.forEach((item) => {
    if (item.key === "validityMonths") {
      item.selectOptions = !value
        ? [...item.selectOptions, { value: 0, label: "—", key: "validityMonths" }]
        : item.selectOptions.findIndex((elem) => elem.value === 0) > 0
        ? item.selectOptions.filter((elem) => elem.value !== 0)
        : item.selectOptions;
      item.disabled = !value;
    }
    if (item.key === "actDate" || item.key === "recuser") {
      item.neededInModal = !value;
    }
  });
  return boatTo;
};

export const filterOptionsValidityMonths = (type, ages, engPower) => {
  if (Number(ages) === NaN) {
    boatTo.nameColumn[3].selectOptions = optionsValidityMonths.filter((item) => item.value === 12);
  } else {
    switch (type) {
      case 6:
        boatTo.nameColumn[3].selectOptions =
          new Date().getFullYear() >= Number(ages) + 9
            ? optionsValidityMonths.filter((item) => item.value === 12)
            : optionsValidityMonths.filter((item) => item.value === 60);
        break;
      case 5:
        boatTo.nameColumn[3].selectOptions =
          new Date().getFullYear() >= Number(ages) + 9
            ? optionsValidityMonths.filter((item) => item.value === 12)
            : optionsValidityMonths.filter((item) => item.value === 24);
        break;
      default:
        if (engPower) {
          boatTo.nameColumn[3].selectOptions =
            new Date().getFullYear() >= Number(ages) + 9
              ? optionsValidityMonths.filter((item) => item.value === 12)
              : optionsValidityMonths.filter((item) => item.value === 36);
        } else {
          boatTo.nameColumn[3].selectOptions =
            new Date().getFullYear() >= Number(ages) + 9
              ? optionsValidityMonths.filter((item) => item.value === 12)
              : optionsValidityMonths.filter((item) => item.value === 24);
        }
        break;
    }
  }
  return boatTo;
};

export function setDefaultOptions() {
  boatTo.nameColumn.forEach((item) => {
    if (item.key === "actDate" || item.key === "recuser") {
      item.neededInModal = false;
    }
    if (item.key === "validityMonths") {
      item.disabled = false;
    }
  });
}
